<div class="summary-panel">
  <div class="summary-body">
    <!-- Section: Captured Tables -->
    <div class="section">
      <h3 class="section-title-captured">Captured Tables: {{ capturedTables.length }}</h3>

      <!-- Instructional content (shown when no tables captured) -->
      @if (capturedTables.length === 0) {
        <div class="instruction-box">
          <div class="instruction-icon">
            <i class="fas fa-magnifying-glass"></i>
          </div>
          <div class="instruction-content">
            <p class="instruction-text">Use this feature to capture any additional tables from the source document.</p>
            <ul class="instruction-steps">
              <li>
                <i class="fas fa-check"></i>
                <span>Search for a table using the search bar</span>
              </li>
              <li>
                <i class="fas fa-check"></i>
                <span>Select a page in the thumbnail list</span>
              </li>
              <li>
                <i class="fas fa-check"></i>
                <span>Draw on the selected page</span>
              </li>
            </ul>
          </div>
        </div>
      }

      <!-- Captured table cards (shown when tables exist) -->
      @for (table of capturedTables; track table) {
        <div class="table-card"
          [class.selected]="selectedTable === table && table.pageIndex === activePageIndex"
          (click)="onCardClick(table, $event)"
          >
          <div class="card-icon">
            <i class="fas fa-file-alt"></i>
          </div>
          <div class="card-info">
            <div class="card-title">{{ table.title }}</div>
            <div class="card-meta">Pg {{ table.pageNumber }}</div>
          </div>
          <div class="card-actions">
            <button class="btn-action btn-view" (click)="onViewTable(table)">
              View <i class="fas fa-arrow-right"></i>
            </button>
          </div>
        </div>
      }
    </div>
  </div>
</div>
